<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<header class="top-menu">
  <div class="nav-item">
    <button class="btn btn-menu-toggle" (click)="toggleMenu()">
      <i class="fal fa-bars"></i>
    </button>
  </div>

  <div class="nav-item assignments-wrapper ms-auto">
    <div class="dropdown-wrapper" *ngIf="canUseCheckInOut()">
      <button
        type="button"
        class="btn-ico-header check-in-out-button margin-sm"
        [ngClass]="{
          'checked-in': checkInOutStatus?.is_open && !checkInOutStatus?.is_blocked,
          'checked-out': !checkInOutStatus?.is_open,
          blocked: checkInOutStatus?.is_blocked
        }"
        [ngbTooltip]="
          (checkInOutStatus?.is_blocked
            ? 'HEADER.CHECK_IN_OUT_BLOCKED_TOOLTIP'
            : checkInOutStatus?.is_open
              ? 'HEADER.CHECK_IN_OUT_CHECK_OUT_TOOLTIP'
              : 'HEADER.CHECK_IN_OUT_CHECK_IN_TOOLTIP') | translate
        "
        container="body"
        [disabled]="checkInOutLoading || checkInOutStatus?.is_blocked"
        (click)="toggleCheckInOut()"
      >
        <div class="spinner-border spinner-border-sm" *ngIf="checkInOutLoading" role="status"></div>
        <ng-container *ngIf="!checkInOutLoading">
          <span class="check-in-out-label">
            {{
              (checkInOutStatus?.is_blocked
                ? 'HEADER.CHECK_IN_OUT_BLOCKED'
                : checkInOutStatus?.is_open
                  ? 'HEADER.CHECK_IN_OUT_CHECK_OUT'
                  : 'HEADER.CHECK_IN_OUT_CHECK_IN') | translate
            }}
          </span>
          <span class="check-in-out-duration" *ngIf="checkInOutMinutesLabel">
            {{ checkInOutMinutesLabel }}
          </span>
        </ng-container>
      </button>
    </div>

    <div class="dropdown-wrapper" ngbDropdown placement="bottom-right" (openChange)="assignmentsDropdownToggle($event)">
      <a
        class="btn-ico-header assignments-dropdown margin-sm"
        ngbDropdownToggle
        [ngbTooltip]="'HEADER.ASSIGNMENTS_TOOLTIP' | translate"
        container="body"
      >
        <i class="fa fa-exclamation"></i>
      </a>

      <div ngbDropdownMenu>
        <ng-container *ngIf="assignments">
          <ng-container *ngFor="let assignment of assignments | keyvalue; let i = index">
            <button class="dropdown-item relative" (click)="assignmentClick(assignment)">
              {{ 'HEADER.ASSIGNMENTS.ASSIGNMENT_SHORT_' + (assignment.key | uppercase) | translate }}
              <span class="badge bg-danger">{{ assignment.value }}</span>
            </button>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="!assignments">
          <div class="assignments-dropdown-spinner-wrapper d-flex justify-content-center align-items-center">
            <div class="spinner-border" role="status"></div>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="dropdown-wrapper" ngbDropdown placement="bottom-right">
      <a
        class="btn-ico-header quick-create-dropdown margin-sm"
        ngbDropdownToggle
        [ngbTooltip]="'HEADER.QUICK_CREATE_BTN_TOOLTIP' | translate"
        container="body"
      >
        <i class="far fa-plus"></i>
      </a>

      <div ngbDropdownMenu>
        <button class="dropdown-item" (click)="createSale()">
          {{ 'HEADER.QUICK_CREATE.SALE' | translate }}
        </button>
        <button class="dropdown-item" (click)="createPayment()">
          {{ 'HEADER.QUICK_CREATE.PAYMENT' | translate }}
        </button>
        <button class="dropdown-item" (click)="createInvoice()">
          {{ 'HEADER.QUICK_CREATE.INVOICE' | translate }}
        </button>
        <button class="dropdown-item" (click)="createBooking()">
          {{ 'HEADER.QUICK_CREATE.BOOKING' | translate }}
        </button>
        <button class="dropdown-item" (click)="createClient()">
          {{ 'HEADER.QUICK_CREATE.CLIENT' | translate }}
        </button>
        <button class="dropdown-item" (click)="createEvent()">
          {{ 'HEADER.QUICK_CREATE.EVENT' | translate }}
        </button>
        <button class="dropdown-item" (click)="createEventGroup()">
          {{ 'HEADER.QUICK_CREATE.EVENT_GROUP' | translate }}
        </button>
        <button class="dropdown-item" (click)="createHotel()">
          {{ 'HEADER.QUICK_CREATE.HOTEL' | translate }}
        </button>
        <button class="dropdown-item" (click)="createVenue()">
          {{ 'HEADER.QUICK_CREATE.VENUE' | translate }}
        </button>
        <button class="dropdown-item" (click)="createSupplier()">
          {{ 'HEADER.QUICK_CREATE.SUPPLIER' | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="nav-item border-start">
    <div
      class="inner-dropdown-wrapper"
      ngbDropdown
      autoClose="outside"
      placement="bottom-right"
      (openChange)="onNotificationsDropdownOpenChange($event)"
    >
      <a
        class="nav-link btn-ico-header notifications-dropdown"
        ngbDropdownToggle
        container="body"
        [ngbTooltip]="'HEADER.NOTIFICATIONS.DROPDOWN_TRIGGER' | translate"
      >
        <i class="far fa-flag"></i>
        <span class="badge bg-danger">{{ notificationsCount }}</span>
      </a>
      <div class="notifications-dropdown-menu" *ngIf="notifications" ngbDropdownMenu>
        <div class="dropdown-header">
          <div class="dropdown-title">
            {{ 'HEADER.NOTIFICATIONS.DROPDOWN_HEADER' | translate }}
          </div>
        </div>
        <ng-scrollbar
          #notificationsScroll
          class="options-list notifications-options-list"
          visibility="native"
          appearance="compact"
          orientation="vertical"
          *ngIf="notifications && notifications.length > 0"
        >
          <div
            *ngFor="let notification of notifications"
            (click)="openNotification(notification)"
            class="dropdown-item reminder-item"
          >
            <span class="short-note w-100">
              {{ notification.text }}
            </span>
          </div>
        </ng-scrollbar>
        <div class="ps-3 pe-3 p-1" *ngIf="!notifications || notifications.length <= 0">
          {{ 'HEADER.NOTIFICATIONS.NO_NOTIFICATIONS' | translate }}
        </div>
        <div class="dropdown-footer justify-content-center">
          <button ngbDropdownToggle class="btn" routerLink="/notifications">
            {{ 'HEADER.NOTIFICATIONS.VIEW_NOTIFICATIONS' | translate }}
          </button>
        </div>
      </div>
    </div>

    <!--<div class="inner-dropdown-wrapper" ngbDropdown placement="bottom-right">
      <a
        class="nav-link btn-ico-header tasks-dropdown"
        ngbDropdownToggle
        [ngbTooltip]="'HEADER.REMINDER.DROPDOWN_TRIGGER' | translate"
        container="body"
      >
        <i class="far fa-thumbtack"></i>
      </a>
      <div class="tasks-dropdown-menu" ngbDropdownMenu [perfectScrollbar]>
        <div class="dropdown-header">
          {{ 'HEADER.REMINDER.DROPDOWN_HEADER' | translate }}
        </div>
        Tasks dropdown
      </div>
    </div>-->
  </div>

  <div class="nav-item border-start">
    <div
      class="inner-dropdown-wrapper"
      ngbDropdown
      placement="bottom-right"
      (openChange)="onRemindersDropdownOpenChange($event)"
    >
      <a
        class="nav-link btn-ico-header reminders-dropdown"
        ngbDropdownToggle
        [ngbTooltip]="'HEADER.REMINDER.DROPDOWN_TRIGGER' | translate"
        container="body"
      >
        <i class="far fa-bell"></i>
        <span class="badge bg-danger">{{ remindersCount }}</span>
      </a>
      <div class="reminders-dropdown-menu" *ngIf="reminders" ngbDropdownMenu>
        <div class="dropdown-header">
          <div class="dropdown-title">
            {{ 'HEADER.REMINDER.DROPDOWN_HEADER' | translate }}
          </div>
        </div>
        <ng-scrollbar
          #remindersScroll
          class="options-list reminders-options-list"
          visibility="native"
          appearance="compact"
          orientation="vertical"
          *ngIf="reminders && reminders.length > 0"
        >
          <div *ngFor="let reminder of reminders" class="dropdown-item reminder-item" (click)="openReminder(reminder)">
            <div class="item-header">
              <span class="type">
                {{ reminder.cleanReminderableType }}
              </span>
              <span class="date">
                <span class="text">{{ reminder.remind_at | date : env.pipeDateFormat }}</span>
              </span>
            </div>
            <span *ngIf="reminder.note" class="short-note w-100">
              {{ reminder.note.length > 45 ? (reminder.note | slice : 0 : 55) + '...' : reminder.note }}
            </span>
            <span *ngIf="!reminder.note" class="short-note w-100">—</span>
          </div>
        </ng-scrollbar>
        <div class="ps-3 pe-3 p-1" *ngIf="!reminders || reminders.length <= 0">
          {{ 'HEADER.REMINDER.NO_REMINDER' | translate }}
        </div>
        <div class="dropdown-footer">
          <button ngbDropdownToggle class="btn btn-view-more" routerLink="/reminders">
            {{ 'HEADER.REMINDER.VIEW_MORE_LINK' | translate }}
          </button>
        </div>
      </div>
    </div>

    <!--<div class="inner-dropdown-wrapper" ngbDropdown placement="bottom-right">
      <a
        class="nav-link btn-ico-header tasks-dropdown"
        ngbDropdownToggle
        [ngbTooltip]="'HEADER.REMINDER.DROPDOWN_TRIGGER' | translate"
        container="body"
      >
        <i class="far fa-thumbtack"></i>
      </a>
      <div class="tasks-dropdown-menu" ngbDropdownMenu [perfectScrollbar]>
        <div class="dropdown-header">
          {{ 'HEADER.REMINDER.DROPDOWN_HEADER' | translate }}
        </div>
        Tasks dropdown
      </div>
    </div>-->
  </div>

  <div class="nav-item border-start" ngbDropdown placement="bottom-right">
    <a id="user-dropdown" class="user-dropdown" ngbDropdownToggle>
      <app-user-box [user]="user" class="d-inline-block"></app-user-box>
    </a>
    <div class="users-dropdown-menu" ngbDropdownMenu aria-labelledby="user-dropdown">
      <button class="dropdown-item" (click)="openProfile()">
        {{ 'HEADER.MY_PROFILE' | translate }}
      </button>
      <button class="dropdown-item" (click)="cacheClear()">{{ 'HEADER.CACHE_CLEAR' | translate }}</button>
      <button class="dropdown-item" (click)="clearFilters()">{{ 'HEADER.FILTERS_CLEAR' | translate }}</button>
      <button class="dropdown-item" (click)="logout()" translate>Logout</button>
    </div>
  </div>
</header>
